var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contain"},[_c('h2',[_vm._v(_vm._s(_vm.header))]),_c('p',[_vm._v(_vm._s(_vm.body))]),_c('CardActions',[_c('Button',{attrs:{"label":_vm.label},on:{"click":_vm.hideModal}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }